var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/treatment-salary-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-560909da!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/treatment-salary-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TreatmentSalaryList.vue
// module id = 1355
// module chunks = 1